import { render, staticRenderFns } from "./EcosystemProfile.vue?vue&type=template&id=0ab5d4f9&scoped=true&"
import script from "./EcosystemProfile.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcosystemProfile.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EcosystemProfile.vue?vue&type=style&index=0&id=0ab5d4f9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5d4f9",
  null
  
)

export default component.exports